<template>
  <div class="index">
      <div class="top wow fadeInDown">
          <div class="header">
              <div class="left wow fadeInDown" data-wow-duration="2s">DOT TECHNOLOGY CHILE SPA</div>
          </div>
          <div class="content">
              <div class="title1  wow bounceInLeft"  data-wow-duration="2s">DOT TECHNOLOGY CHILE SPA</div>
              <div class="content_font wow fadeInUp" data-wow-duration="2s">Use AI technology to transform and reshape business and provide users </div>
              <div class="content_font wow fadeInUp" data-wow-duration="2s">with better information, products and services. </div>
          </div>
      </div>
      <div class="about">
          <div class="content">
            <img class="point wow fadeInRight" src="../../assets/combinedShape.png"/>
            <div class="left  wow fadeInDown">
                <div class="title wow fadeInLeft" data-wow-duration="1.5s">DOT TECHNOLOGY CHILE SPA</div>
                <div class="title1 wow fadeInLeft" data-wow-duration="2s">ABOUT US</div>
                <div class="wow fadeInLeft" data-wow-duration="2.5s">DOT TECHNOLOGY CHILE SPA HK LIMITED is a technology-based company, focusing on the in-depth research and development of big data, computer vision, machine learning, natural language processing and other related technologies through software-as-a-service solutions, helping enterprises achieve intelligent digital transformation, anti-fraud strategy design and process automation deployment, focusing on the service industry, and providing them with digital transformation, anti-fraud and process automation solutions.</div>
            </div>
            <div class="right wow fadeInRight" data-wow-duration="2s" data-wow-delay="0.8s"><img src="../../assets/banner.png"/></div>
          </div>
      </div>
      <div class="service">
          <div class="header">
              <div class="left">
                <div class="title wow fadeInLeft" data-wow-duration="2s">DOT TECHNOLOGY CHILE SPA</div>
                <div class="title1 wow fadeInUp" data-wow-duration="2s">Service Introduction</div>
              </div>
              <div class="right wow fadeInRight" data-wow-duration="2.5s">
                  <div>We provide customers with one-stop solutions by </div>
                  <div>integrating data, technology, ethical compliance </div>
                  <div>and ideological creativity in compliance.</div>
              </div>
          </div>
          <div class="introduction">
              <div class="left">
                  <div class="wow fadeInLeft" data-wow-duration="2s" style="margin-top:0"><img src="../../assets/introduceIcon1.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s"><img src="../../assets/introduceIcon2.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s"><img src="../../assets/introduceIcon1.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s"><img src="../../assets/introduceIcon2.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s"><img src="../../assets/introduceIcon1.png"/></div>
                  <div class="wow fadeInLeft" data-wow-duration="2s" style="margin-bottom:0"><img src="../../assets/introduceIcon2.png"/></div>
              </div>
              <div class="right">
                  <img class="point wow fadeInRight" src="../../assets/combinedShape.png"/>
                  <div class="wow fadeInRight item" data-wow-duration="2s">Support "collection and labeling" one-stop service - full process, easy to expand.</div>
                  <div class="wow fadeInRight item" data-wow-duration="2s">Support the acquisition and labeling of image, voice, language, video and other morphological data.</div>
                  <div class="wow fadeInRight item" data-wow-duration="2s">Provide privatization and customized deployment of data annotation system.</div>
                  <div class="wow fadeInRight item" data-wow-duration="2s">Triple check of data inspection to ensure that data processing achieves more than 99.8% of the qualified rate.</div>
                  <div class="wow fadeInRight item" data-wow-duration="2s">Establish a standardized process, have a complete personnel and management training mechanism, and ensure the professional ability of the data management team.</div>
                  <div class="wow fadeInRight item" data-wow-duration="2s" style="margin:0">Provide localized data processing strategy, high cost performance, safe and professional data management.</div>
                  <!-- <div class="priceBtn">
                      <div class="wow fadeInRight btn" @click="openChile" data-wow-duration="2s" >
                          <img src="../../assets/chile.png"/>CHILE
                      </div>
                      <div style="width:60px"></div>
                      <div class="wow fadeInRight btn" @click="openPeru" data-wow-duration="2s" >
                          <img src="../../assets/peru.png"/>PERU
                      </div>
                  </div> -->
              </div>
          </div>
      </div>
      <div class="our">
        <div class="content">
            <div class="item wow fadeInUp" data-wow-duration="2s">
                <div>CUSTOMER <br/>ORIENTED</div>
                <img src="../../assets/ourIcon3.png"/>
            </div>
            <div class="item wow fadeInUp" data-wow-duration="3s" data-wow-delay="0.5s">
                <div>EVIDENCE <br/>ORIENTED</div>
                <img src="../../assets/ourIcon1.png"/>
            </div>
            <div class="item wow fadeInUp" data-wow-duration="4s" data-wow-delay="1s">
                <div>PEOPLE <br/>ORIENTED</div>
                <img src="../../assets/ourIcon2.png"/>
            </div>
            <div class="title wow fadeInUp" data-wow-duration="4s">
                <div>DOT TECHNOLOGY CHILE SPA</div>
                <div class="title_font">OUR <br/>CULTURE</div>
                <img class="point" src="../../assets/combinedShape.png"/>
            </div>
        </div>
      </div>
      <div class="footer">
          <div class="content">
            <div>DOT TECHNOLOGY CHILE SPA</div>
            <div class="title">Sense of worth</div>
            <div class="sence">
                <div class="item">
                    <img src="../../assets/senceIcon1.png"/>
                    <div class="item_title">INNOVATION</div>
                    <div class="item_content">Start business from beginning to the end ; Optimistic view of change; Try new solutions to surprise customers.</div>
                </div>
                <div class="item">
                    <img src="../../assets/senceIcon2.png"/>
                    <div class="item_title">BE REALISTIC</div>
                    <div class="item_content">Insist on doing the right thing;  Because of sincerity,  it is simple;  Based on the facts, do what you say.</div>
                </div>
                <div class="item">
                    <img src="../../assets/senceIcon3.png"/>
                    <div class="item_title">REFINEMENT</div>
                    <div class="item_content">High quality, starts from me; Think more and do more; Make small things beautiful and details perfect.</div>
                </div>
            </div>
          </div>
      </div>
        <Modal v-model="chileModal" width="80%" class-name="vertical-center-modal">
            <template #header>
                <p class="modalTitle">
                    CHILE SERVICES
                </p>
            </template>
            <div class="modalBody">
                <div class="title">Price</div>
                <div>
                    <RadioGroup v-model="type" type="button" size="large">
                        <Radio label="1">25,000 CLP / Month</Radio>
                        <Radio label="2">65,000 CLP / Quater</Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px">
                    <RadioGroup v-model="type" type="button" size="large">
                        <Radio label="3">125,000 CLP / 6 months</Radio>
                        <Radio label="4">240,000 CLP/ Year</Radio>
                    </RadioGroup>
                </div>
                <div class="title" style="margin-top:16px">Payment Method</div>
                <div style="margin-top:16px" class="methodItem icon1">
                    <RadioGroup class="icon1" @on-change="openTips" v-model="method" type="button" size="large" style="margin-top:16px">
                        <Radio label="1">
                            <span>Bank Transfer</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon2">
                    <RadioGroup v-model="method" @on-change="openTips" type="button" size="large">
                        <Radio label="2">
                            <span>Debit Card</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon3">
                    <RadioGroup v-model="method" @on-change="openTips" type="button" size="large">
                        <Radio label="3">
                            <span>Credit Card</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon4">
                    <RadioGroup v-model="method" @on-change="openTips" type="button" size="large" style="margin-top:16px">
                        <Radio label="4">
                            <span>Cash Payment</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
            </div>
            <template #footer>
                <Icon type="ios-alert-outline" />
                <span>Note: want to know more about price please contact our customer service staff</span>
            </template>
        </Modal>
        <Modal v-model="peruModal" width="80%" class-name="vertical-center-modal">
            <template #header>
                <p class="modalTitle">
                    PERU SERVICES
                </p>
            </template>
            <div class="modalBody">
                <div class="title">Price</div>
                <div>
                    <RadioGroup v-model="peruType" type="button" size="large">
                        <Radio label="1">100 PEN /Month</Radio>
                        <Radio label="2">270 PEN / Quater</Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px">
                    <RadioGroup v-model="peruType" type="button" size="large">
                        <Radio label="3">500 PEN / 6 months</Radio>
                        <Radio label="4">950 PEN/ Year</Radio>
                    </RadioGroup>
                </div>
                <div class="title" style="margin-top:16px">Payment Method</div>
                <div style="margin-top:16px" class="methodItem icon1">
                    <RadioGroup @on-change="openTips" v-model="peruMethod" type="button" size="large" style="margin-top:16px">
                        <Radio label="1">
                            <span>Bank Transfer</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon2">
                    <RadioGroup v-model="peruMethod" @on-change="openTips" type="button" size="large">
                        <Radio label="2">
                            <span>Debit Card</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon3">
                    <RadioGroup v-model="peruMethod" @on-change="openTips" type="button" size="large">
                        <Radio label="3">
                            <span>Credit Card</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
                <div style="margin-top:16px" class="methodItem icon4">
                    <RadioGroup v-model="peruMethod" @on-change="openTips" type="button" size="large" style="margin-top:16px">
                        <Radio label="4">
                            <span>Cash Payment</span>
                            <Icon class="right" type="ios-arrow-forward" size="24"/>
                        </Radio>
                    </RadioGroup>
                </div>
            </div>
            <template #footer>
                <Icon type="ios-alert-outline" />
                <span>Note: want to know more about price please contact our customer service staff</span>
            </template>
        </Modal>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
import { Message } from 'element-ui';
export default {
  data () {
    return {
      chileModal:false,
      peruModal:false,
      type:'1',
      method:'',
      peruType:'1',
      peruMethod:'',

    }
  },
  methods:{
      openChile(){
          this.chileModal = true
          this.type='1'
          this.method = ''
      },
      openPeru(){
          this.peruModal = true
          this.peruType='1'
          this.peruMethod = ''
      },
      openTips(){
          Message.success({message:'Stay Tuned'})
      }
  },
  mounted () {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      const wow = new WOW({
        live: false
      })
      wow.init()
    })
  }
}
</script>

<style lang="less" scoped>
@media all and (min-width:1440px){
    .index{
        position: relative;
        width: 100%;
        min-width: 1750px;
        .top{
            min-width: 1172px;
            padding: 20px 232px;
            background: url('../../assets/background.png') no-repeat;
            border-radius: 0px 0px 100px 100px;
            background-size: 100% 100%;
            .header{
                width: 1368px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .left{
                    font-size: 30px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 48px;
                    margin-left:0px
                }
            }
            .content{
                width: 1368px;
                margin: 0 auto;
                padding: 296px 0 338px 0;
                .title1{
                    font-size: 72px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #6AFFEE;
                    line-height: 84px;
                    color: #53F1D6;
                    padding-bottom: 31px;
                }
                .content_font{
                    font-size: 20px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 32px;
                }
            }
        }
        .about{
            padding: 160px 232px;
            .content{
                width: 1368px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                .point{
                    position: absolute;
                    right: -143px;
                    top: 193px;
                }
            }
            .left{
                font-size: 22px;
                font-family: Montserrat-Regular, Montserrat;
                font-weight: 400;
                color: #333333;
                line-height: 38px;
                width: 486px;
                .title{
                    font-size: 28px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #71D2FF;
                    line-height: 32px;
                }
                .title1{
                    font-size: 62px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #333333;
                    line-height: 56px;
                    padding: 25px 0 32px 0;
                }
            }
        }
        .service{
            min-width: 1368px;
            background: #F7F7F7;
            border-radius: 100px 0px 0px 0px;
            padding: 71px 232px 98px 232px;
            .header{
                width: 1368px;
                margin: 0 auto;
                font-size: 18px;
                font-family: Montserrat-Regular, Montserrat;
                font-weight: 400;
                color: #333333;
                line-height: 32px;
                display: flex;
                justify-content: space-between;
                padding-bottom: 74px;
                .left{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    .title{
                        font-size: 24px;
                        font-family: Montserrat-Light, Montserrat;
                        font-weight: 300;
                        color: #6071EC;
                        line-height: 32px;
                    }
                    .title1{
                        font-size: 56px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #333333;
                        line-height: 56px;
                        margin-top: 22px;
                    }
                }
                .right{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                }
            }
            .introduction{
                width: 1368px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .left{
                    div{
                        margin: 127px 0;
                    }
                }
                .right{
                    position: relative;
                    font-size: 22px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #333333;
                    line-height: 32px;
                    .item{
                        position: relative;
                        display: flex;
                        align-items: center;
                        width: 1170px;
                        height: 110px;
                        background: #FFFFFF;
                        box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.1);
                        border-radius: 16px;
                        margin-bottom: 69px;
                        padding: 0 48px;
                        z-index:999;
                    }
                    .point{
                        position: absolute;
                        right: -47px;
                        top: 47px;
                        z-index:1;
                    }
                    .priceBtn{
                        margin-top: 100px;
                        display: flex;
                        justify-content: right;
                        font-size: 43px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #6374EC;
                        line-height: 43px;
                        .btn{
                            cursor: pointer;
                        }
                        img{
                            vertical-align: -10px;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
        .our{
            padding: 160px 232px;
            .content{
                width: 1368px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .item{
                    width: 270px;
                    height: 320px;
                    background: #00D1FF;
                    box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.1);
                    border-radius: 16px;
                    font-size: 24px;
                    font-family: Montserrat-SemiBold, Montserrat;
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 32px;
                    padding: 40px 48px;
                    position: relative;
                    img{
                        position: absolute;
                        right: 48px;
                        bottom: 45px;
                    }
                }
                .title{
                    width: 272px;
                    height: 300px;
                    font-size: 24px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #6374EC;
                    line-height: 32px;
                    margin-left: 50px;
                    position: relative;
                    .title_font{
                        font-size: 56px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #333333;
                        line-height: 64px;
                    }
                    .point{
                        position: absolute;
                        right: 0px;
                        top: 127px;
                    }
                }
            }
        }
        .footer{
            min-width: 1368px;
            border-radius: 100px 100px 0px 0px;
            padding: 71px 232px 166px 232px;
            background-color: #0039A6;
            .content{
                width: 1368px;
                margin: 0 auto;
                font-size: 24px;
                font-family: Montserrat-Light, Montserrat;
                font-weight: 300;
                color: #6AFFEE;
                line-height: 32px;
                .title{
                    font-size: 56px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 64px;
                    margin-top:18px;
                    margin-bottom:87px;
                }
                .sence{
                    display: flex;
                    justify-content: space-around;
                    .item{
                        width: 370px;
                        height: 442px;
                        background: #F7F7F7;
                        border-radius: 16px;
                        padding: 16px;
                        .item_title{
                            font-size: 24px;
                            font-family: Montserrat-Bold, Montserrat;
                            font-weight: bold;
                            color: #333333;
                            line-height: 32px;
                            margin-left: 32px;
                            margin-top: 12px;
                        }
                        .item_content{
                            font-size: 18px;
                            font-family: Montserrat-Light, Montserrat;
                            font-weight: 300;
                            color: #333333;
                            line-height: 32px;
                            margin-left: 32px;
                            margin-top: 12px;
                        }
                    }
                }
            }
        }
    }
}
@media all and (max-width:1440px){
    .index{
        position: relative;
        width: 100%;
        min-width: 1440px;
        .top{
            min-width: 1072px;
            padding: 20px 134px;
            background: url('../../assets/background.png') no-repeat;
            border-radius: 0px 0px 100px 100px;
            background-size: 100% 100%;
            .header{
                width: 1082px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .left{
                    font-size: 30px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 48px;
                    margin-left:0px
                }
            }
            .content{
                width: 1172px;
                margin: 0 auto;
                padding: 296px 0 338px 0;
                .title1{
                    font-size: 72px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #6AFFEE;
                    line-height: 84px;
                    color: #53F1D6;
                    padding-bottom: 31px;
                }
                .content_font{
                    font-size: 20px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 32px;
                }
            }
        }
        .about{
            padding: 160px 134px;
            .content{
                width: 1172px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                .point{
                    position: absolute;
                    right: -43px;
                    top: 193px;
                }
            }
            .left{
                font-size: 18px;
                font-family: Montserrat-Regular, Montserrat;
                font-weight: 400;
                color: #333333;
                line-height: 32px;
                width: 406px;
                .title{
                    font-size: 24px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #71D2FF;
                    line-height: 32px;
                }
                .title1{
                    font-size: 56px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #333333;
                    line-height: 56px;
                    padding: 25px 0 32px 0;
                }
            }
        }
        .service{
            min-width: 1072px;
            background: #F7F7F7;
            border-radius: 100px 0px 0px 0px;
            padding: 71px 134px 98px 134px;
            .header{
                width: 1172px;
                margin: 0 auto;
                font-size: 18px;
                font-family: Montserrat-Regular, Montserrat;
                font-weight: 400;
                color: #333333;
                line-height: 32px;
                display: flex;
                justify-content: space-between;
                padding-bottom: 74px;
                .left{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    .title{
                        font-size: 24px;
                        font-family: Montserrat-Light, Montserrat;
                        font-weight: 300;
                        color: #6071EC;
                        line-height: 32px;
                    }
                    .title1{
                        font-size: 56px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #333333;
                        line-height: 56px;
                        margin-top: 22px;
                    }
                }
                .right{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                }
            }
            .introduction{
                width: 1172px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .left{
                    div{
                        margin: 127px 0;
                    }
                }
                .right{
                    font-size: 22px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #333333;
                    line-height: 32px;
                    position: relative;
                    .point{
                        position: absolute;
                        right: -43px;
                        top: 49px;
                    }
                    .item{
                        position: relative;
                        display: flex;
                        align-items: center;
                        width: 974px;
                        height: 110px;
                        background: #FFFFFF;
                        box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.1);
                        border-radius: 16px;
                        margin-bottom: 69px;
                        padding: 0 48px;
                    }
                    .priceBtn{
                        margin-top: 100px;
                        display: flex;
                        justify-content: right;
                        font-size: 43px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #6374EC;
                        line-height: 43px;
                        .btn{
                            cursor: pointer;
                        }
                        img{
                            vertical-align: -10px;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
        .our{
            padding: 160px 134px;
            .content{
                width: 1172px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .item{
                    width: 270px;
                    height: 320px;
                    // width: 174px;
                    // height: 240px;
                    background: #00D1FF;
                    box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.1);
                    border-radius: 16px;
                    font-size: 24px;
                    font-family: Montserrat-SemiBold, Montserrat;
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 32px;
                    padding: 40px 48px;
                    position: relative;
                    img{
                        position: absolute;
                        right: 48px;
                        bottom: 45px;
                    }
                }
                .title{
                    width: 272px;
                    height: 300px;
                    font-size: 24px;
                    font-family: Montserrat-Regular, Montserrat;
                    font-weight: 400;
                    color: #6374EC;
                    line-height: 32px;
                    margin-left: 50px;
                    position: relative;
                    .point{
                        position: absolute;
                        right: 0px;
                        top: 129px;
                    }
                    .title_font{
                        font-size: 56px;
                        font-family: Montserrat-Bold, Montserrat;
                        font-weight: bold;
                        color: #333333;
                        line-height: 64px;
                    }
                }
            }
        }
        .footer{
            min-width: 1072px;
            border-radius: 100px 100px 0px 0px;
            padding: 71px 134px 166px 134px;
            background-color: #0039A6;
            .content{
                width: 1172px;
                margin: 0 auto;
                font-size: 24px;
                font-family: Montserrat-Light, Montserrat;
                font-weight: 300;
                color: #6AFFEE;
                line-height: 32px;
                .title{
                    font-size: 56px;
                    font-family: Montserrat-Bold, Montserrat;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 64px;
                    margin-top:18px;
                    margin-bottom:87px;
                }
                .sence{
                    display: flex;
                    justify-content: space-around;
                    .item{
                        width: 370px;
                        height: 442px;
                        // width: 336px;
                        // height: 432px;
                        background: #F7F7F7;
                        border-radius: 16px;
                        padding: 16px;
                        .item_title{
                            font-size: 24px;
                            font-family: Montserrat-Bold, Montserrat;
                            font-weight: bold;
                            color: #333333;
                            line-height: 32px;
                            margin-left: 32px;
                            margin-top: 12px;
                        }
                        .item_content{
                            font-size: 18px;
                            font-family: Montserrat-Light, Montserrat;
                            font-weight: 300;
                            color: #333333;
                            line-height: 32px;
                            margin-left: 32px;
                            margin-top: 12px;
                        }
                    }
                }
            }
        }
    }
}
.modalTitle{
    font-size: 28px;
    font-family: Montserrat-Bold, Montserrat;
    font-weight: bold;
    color: #333333;
    line-height: 28px;
    height: 28px;
}
.modalBody{
    .title{
        font-size: 20px;
        font-family: Montserrat-SemiBold, Montserrat;
        font-weight: 600;
        color: #333333;
        line-height: 29px;
        margin-bottom: 16px;
    }
}

</style>
<style lang="less">
.ivu-modal-content{
    border-radius: 10px!important;
}
.ivu-modal-header{
    padding: 28px!important;
}
.ivu-modal-body{
    padding: 28px!important;
}
.ivu-modal-footer{
    text-align: left!important;
    padding: 28px!important;
    padding-top: 16px!important;
    font-size: 20px!important;
    font-family: Montserrat-Medium, Montserrat!important;
    font-weight: 500!important;
    color: #FA8218!important;
}
.ivu-modal-close{
    top:20px!important;
    right: 20px!important;
}
.ivu-modal-close .ivu-icon-ios-close{
    font-size: 40px!important;
}
.ivu-radio-group-button{
    width:100%!important;
    display: flex!important;
    justify-content: space-between!important;
}
.ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
    width: 49%!important;
    border: 2px solid #E3E8EF!important;
    border-radius: 8px!important;
    text-align: center!important;
    font-size: 20px!important;
    font-family: Montserrat-SemiBold, Montserrat;
    font-weight: 600!important;
    color: #677489;
    height: 60px!important;
    line-height: 60px!important;
    letter-spacing: 1px!important;
}
.ivu-radio-group-button .ivu-radio-wrapper:after, .ivu-radio-group-button .ivu-radio-wrapper:before{
    display: none!important;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked{
    background-color: #6374EC!important;
    color: #FFFFFF !important;
    box-shadow:0 0 0 0!important;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:first-child{
    box-shadow:0 0 0 0!important;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus{
    box-shadow:0 0 0 0!important;
}
.methodItem{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        width:100% !important;
        text-align:left !important;
        border-radius:8px !important;
        padding-left: 60px!important;
        background-repeat: no-repeat!important;
        background-position-x: 20px!important;
        background-position-y: 14px;
    }
    .right{
        float: right;
        margin-top: 17px;
    }
}
.icon1{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        background-image: url('../../assets/bank_b.png');
    }
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked{
        background-image: url('../../assets/bank_w.png') !important;
    }
}
.icon2{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        background-image: url('../../assets/card_b.png');
    }
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked{
        background-image: url('../../assets/card_w.png') !important;
    }
}
.icon3{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        background-image: url('../../assets/credit_b.png');
    }
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked{
        background-image: url('../../assets/credit_w.png') !important;
    }
}
.icon4{
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{
        background-image: url('../../assets/cash_b.png');
    }
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked{
        background-image: url('../../assets/cash_w.png') !important;
    }
}
.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    
    .ivu-modal {
        top: -20px;
    }
}
.el-message{
    min-width: 480px !important;
    padding: 20px 20px 20px 25px !important;
}
</style>


// WEBPACK FOOTER //
// src/page/index/index.vue